import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ContentCardProps {
  children: ReactNode;
  className?: string;
}

export const ContentCard = (props: ContentCardProps) => (
  <div className={cn('overflow-hidden rounded-xl border border-white/[0.06]', props.className)}>
    {props.children}
  </div>
);

export const EmptyCard = (props: ContentCardProps) => (
  <div className={cn('rounded-xl border border-dashed border-white/[0.08] p-8', props.className)}>
    {props.children}
  </div>
);
